// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default class DotsHorizontalIcon extends React.PureComponent<React.HTMLAttributes<HTMLSpanElement>> {
    render() {
        return (
            <span {...this.props}>
                <svg
                    width='14px'
                    height='4px'
                    viewBox='0 0 14 4'
                    role='img'
                    aria-label='dots horizontal icon'
                >
                    <path d='M10.2 2.00001C10.2 1.56267 10.3547 1.18934 10.664 0.880006C10.984 0.560006 11.3627 0.400006 11.8 0.400006C12.2373 0.400006 12.6107 0.560006 12.92 0.880006C13.24 1.18934 13.4 1.56267 13.4 2.00001C13.4 2.43734 13.24 2.81601 12.92 3.13601C12.6107 3.44534 12.2373 3.60001 11.8 3.60001C11.3627 3.60001 10.984 3.44534 10.664 3.13601C10.3547 2.81601 10.2 2.43734 10.2 2.00001ZM5.4 2.00001C5.4 1.56267 5.55467 1.18934 5.864 0.880006C6.184 0.560006 6.56267 0.400006 7 0.400006C7.43733 0.400006 7.81067 0.560006 8.12 0.880006C8.44 1.18934 8.6 1.56267 8.6 2.00001C8.6 2.43734 8.44 2.81601 8.12 3.13601C7.81067 3.44534 7.43733 3.60001 7 3.60001C6.56267 3.60001 6.184 3.44534 5.864 3.13601C5.55467 2.81601 5.4 2.43734 5.4 2.00001ZM0.6 2.00001C0.6 1.56267 0.754667 1.18934 1.064 0.880006C1.384 0.560006 1.76267 0.400006 2.2 0.400006C2.63733 0.400006 3.01067 0.560006 3.32 0.880006C3.64 1.18934 3.8 1.56267 3.8 2.00001C3.8 2.43734 3.64 2.81601 3.32 3.13601C3.01067 3.44534 2.63733 3.60001 2.2 3.60001C1.76267 3.60001 1.384 3.44534 1.064 3.13601C0.754667 2.81601 0.6 2.43734 0.6 2.00001Z'/>
                </svg>
            </span>
        );
    }
}
